import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description: "For real-time convolution both time signals are converted to the frequency domain as shown below.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/03/18/principle/slide-02.svg`,
            },
          },
          styles: {
            padding: "2% 5%",
          },
        },
      },
    },
  },
};

export default principle;
